import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AdminApi from "api/adminapi/user";
import PagesWrapper from "./Common/Pages/PagesWrapper";
import ShowComponent from "./ShowComponent";
import Button from "./Common/Button";
import UserApi from "api/adminapi/user";
import AppWrapper from "./Routes/AppWrapper";
import AdminSideBar from "./Common/AdminSideBar";
import { toast } from "react-toastify";
import PasswordChecklist from "react-password-checklist";

const CreateAdmin = ({ contentOnly = false, setPopupId, fetchData }) => {
  const [byEmail, setByEmail] = useState(false);
  const [byUserName, setByUserName] = useState(false);
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isActive, setIsActive] = useState(null);

  const [formState, setFormState] = useState({
    role: null,
    roles: [],
    message: "",
    error: "",
    loading: false,
  });
  const [passwordChecklist, setPasswordChecklist] = useState({
    minLength: false,
    specialChar: false,
    number: false,
    capital: false,
    match: false,
  });

  const CurrentUserRole = useSelector(
    (state) => state.auth.currentUser?.role_id
  );

  const handleByEmail = (buttonType) => {
    setIsActive(buttonType);
    setByEmail(!byEmail);
    setByUserName(false);
    setUserName("");
    setPassword("");
    setConfirmPassword("");
  };

  const handleByUserName = (buttonType) => {
    setIsActive(buttonType);
    setByUserName(!byUserName);
    setByEmail(false);
    setEmail("");
  };

  const handlePasswordShow = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmPasswordShow = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    const checklist = {
      minLength: value.length >= 6,
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
      number: /\d/.test(value),
      capital: /[A-Z]/.test(value),
      match: value === confirmPassword,
    };
    setPasswordChecklist(checklist);
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
    setPasswordChecklist((prevChecklist) => ({
      ...prevChecklist,
      match: password === value,
    }));
  };

  const allCriteriaMet = Object.values(passwordChecklist).every((item) => item);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormState((prevFormState) => ({
      ...prevFormState,
      [name]: value,
    }));
  };

  const handleCreateUser = (e) => {
    e.preventDefault();
    if (!allCriteriaMet && byUserName) {
      toast.error("Password Does Not Meet Criteria");
      return;
    }
    setFormState((prevFormState) => ({
      ...prevFormState,
      loading: true,
    }));
    UserApi.sendEmailUser({
      user: {
        username: userName,
        password: password,
        password_confirmation: confirmPassword,
        email: email.toLocaleLowerCase(),
        role_id: parseInt(formState?.role),
      },
    })
      .then((response) => {
        const Message = response
          ? "Invitation has been sent"
          : "An error occurred";
        if (userName && Message === "Invitation has been sent") {
          toast.success("User Created Successfully");
          fetchData();
        } else {
          toast.success(`Success:${Message}`);
          fetchData();
        }
        setPopupId("");
        setFormState((prevFormState) => ({
          ...prevFormState,
          email: "",
          role: "",
          loading: false,
        }));
      })
      .catch((error) => {
        const errorss = error
          ? error?.response?.data.error
          : "An error occurred";
        toast.error(`${errorss}`);
        setFormState((prevFormState) => ({
          ...prevFormState,
          loading: false,
        }));
      });
  };

  useEffect(() => {
    if (CurrentUserRole === 2 || CurrentUserRole === 3) {
      AdminApi.getRole()
        .then((res) => {
          setFormState((prevFormState) => ({
            ...prevFormState,
            roles: res.data.roles,
          }));
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        });
    }
  }, []);

  return (
    <AppWrapper sideBar={<AdminSideBar />} contentOnly={contentOnly}>
      <PagesWrapper>
        <div className="my-4">
          <h1 className="text-24 text-center font-weight-600">Create User</h1>
        </div>
        {CurrentUserRole != 1 && (
        <div className="flex justify-center items-center w-full px-5">
          <button
            className={`flex items-center justify-center w-1/2 h-[44px] mr-2 border-2 rounded-lg border-slate-200 ${
              isActive === "email"
                ? "bg-blue text-white"
                : "bg-white text-black"
            }`}
            onClick={() => handleByEmail("email")}
          >
            By Email
          </button>
          <button
            className={`flex items-center justify-center w-1/2 h-[44px] mr-2 border-2 rounded-lg border-slate-200 ${
              isActive === "username"
                ? "bg-blue text-white"
                : "bg-white text-black"
            }`}
            onClick={() => handleByUserName("username")}
          >
            By Username
          </button>
        </div>
        )}
        <form onSubmit={handleCreateUser}>
          {(byEmail || CurrentUserRole === 1) && (
            <div className="w-full px-4 py-2">
              <div className="flex flex-wrap">
                <div className="w-full px-4 py-2">
                  <div className="mb-2">Email</div>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter email address"
                    type="email"
                    name="email"
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <ShowComponent
                condition={CurrentUserRole === 2 || CurrentUserRole === 3}
              >
                <div className="flex flex-wrap">
                  <div className="w-full px-4 py-2">
                    <div className="mb-2">Role</div>
                    <select
                      value={formState.role}
                      onChange={handleInput}
                      name="role"
                      className="form-control"
                      required
                    >
                      <option value=""> Please select Role</option>
                      {formState.roles
                        .filter(
                          (option) => CurrentUserRole !== 3 || option.type === 4
                        )
                        .map((option, index) => (
                          <option key={index} value={option.type}>
                            {option.role}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </ShowComponent>
              <div className="flex w-full justify-center mt-2">
                <Button
                  className={`${
                    formState.loading
                      ? "flex items-center justify-center w-[30%] h-[50px] disabled btn-progress  "
                      : "flex items-center justify-center w-[30%] h-[50px] btn btn-primary"
                  }`}
                  type="submit"
                >
                  Send Email
                </Button>
                {formState.message && (
                  <div className="alert alert-success mt-3 mb-0">
                    {formState.message}
                  </div>
                )}
                {formState.error && (
                  <div className="alert alert-danger mt-3 mb-0">
                    {formState.error}
                  </div>
                )}
              </div>
            </div>
          )}
          {byUserName && (
            <div className="w-full px-4 py-2">
              <div className="flex flex-wrap">
                <div className=" w-full px-4 py-2">
                  <div className="mb-2">User Name</div>
                  <input
                    className="form-control"
                    value={userName}
                    type="text"
                    placeholder="Enter User Name"
                    onChange={(e) => setUserName(e.target.value)}
                    required
                  />
                </div>
                <div className=" w-full px-4 py-2">
                  <div className="mb-2">Password</div>
                  <div className="relative">
                    <input
                      className="form-control"
                      value={password}
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      required
                      onChange={(e) => handlePasswordChange(e.target.value)}
                    />
                    <span
                      onClick={handlePasswordShow}
                      className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                    >
                      {showPassword ? "👁️" : "🔒"}
                    </span>
                  </div>
                </div>
                <div className=" w-full px-4 py-2">
                  <div className="mb-2">Confirm Password</div>
                  <div className="relative">
                    <input
                      className="form-control"
                      value={confirmPassword}
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      required
                      onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                    />
                    <span
                      onClick={handleConfirmPasswordShow}
                      className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                    >
                      {showConfirmPassword ? "👁️" : "🔒"}
                    </span>
                  </div>
                  <PasswordChecklist
                    rules={[
                      "minLength",
                      "specialChar",
                      "number",
                      "capital",
                      "match",
                    ]}
                    minLength={6}
                    value={password}
                    valueAgain={confirmPassword}
                  />
                </div>
              </div>
              <ShowComponent
                condition={CurrentUserRole === 2 || CurrentUserRole === 3}
              >
                <div className="flex flex-wrap">
                  <div className="w-full px-4 py-2">
                    <div className="mb-2">Role</div>
                    <select
                      className="form-control"
                      value={formState.role}
                      onChange={handleInput}
                      name="role"
                      required
                    >
                      <option value=""> Please select Role</option>
                      {formState.roles
                        .filter(
                          (option) => CurrentUserRole !== 3 || option.type === 4
                        )
                        .map((option, index) => (
                          <option key={index} value={option.type}>
                            {option.role}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </ShowComponent>
              <div className="flex w-full justify-center mt-2">
                <button
                  className={`${
                    formState.loading
                      ? "flex items-center justify-center w-[30%] h-[50px] disabled btn-progress  "
                      : "flex items-center justify-center w-[30%] h-[50px] btn btn-primary"
                  }`}
                  type="submit"
                >
                  Create User
                </button>
                {formState.message && (
                  <div className="alert alert-success mt-3 mb-0">
                    {formState.message}
                  </div>
                )}
                {formState.error && (
                  <div className="alert alert-danger mt-3 mb-0">
                    {formState.error}
                  </div>
                )}
              </div>
            </div>
          )}
        </form>
      </PagesWrapper>
    </AppWrapper>
  );
};

export default CreateAdmin;
